const getRendition = (src, width, height) => src
  .replace('[width]', width)
  .replace('[height]', height)

const getImageRenditions = (
  src = '',
  sizes = [
    '341x192',
    '512x288',
    '768x432',
    '1024x576',
  ],
) => (
  src
    ? {
      _renditions: sizes.reduce((accumulator, size) => ({
        ...accumulator,
        [size]: getRendition(src, ...size.split('x')),
      }), {}),
    }
    : {}
)

export default getImageRenditions
